export * from './interest-rate.component';
